var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.open && _vm.getCompareProducts.length > 1
      ? _c(
          "section",
          { staticClass: "compare-bottom-bar sticky-banner w-100" },
          [
            _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "btn left-tick" }, [
                _c("span", { staticClass: "count" }, [
                  _vm._v(_vm._s(_vm.getCompareProducts.length))
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass:
                    "tick-icon png-icon png-icon-icons-glyph--ko-check"
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex right-side w-100 justify-content-between"
                },
                [
                  _c(
                    "div",
                    { staticClass: "text-uppercase compare-items-count" },
                    [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.$resourceString["product.Search.Label.Compare"]
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-muted" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$resourceString["product.Search.Label.Items"]
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn border border-dark justify-content-start mr-3 hide-mobile-tablet",
                          class: [
                            _vm.sliceStart == 0 ? "disabled-prev-next-btn" : ""
                          ],
                          on: { click: _vm.prev }
                        },
                        [
                          _c("span", {
                            class: [
                              _vm.sliceStart == 0
                                ? "png-icon png-icon-icons-glyph--g-chevron-left"
                                : "png-icon png-icon-icons-glyph--k-chevron-left"
                            ]
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(
                        _vm.getCompareProducts.slice(
                          _vm.sliceStart,
                          _vm.sliceEnd
                        ),
                        function(item, index) {
                          return _c(
                            "div",
                            {
                              key: item.styleNumber,
                              staticClass: "d-flex hide-mobile-tablet"
                            },
                            [
                              _c("div", { staticClass: "mr-3" }, [
                                _c("img", {
                                  staticClass: "tiles-list",
                                  attrs: {
                                    alt: item.colors[0].colorNumber,
                                    src:
                                      _vm.viewMode === "swatch"
                                        ? _vm.$helpers.getColorThumbnailImageUrl(
                                            item.sellingStyleNumber,
                                            item.selectedColor.colorNumber
                                              ? item.selectedColor.colorNumber
                                              : item.colors[0].colorNumber
                                          )
                                        : _vm.$helpers.getInteractiveRoomSceneImageUrl(
                                            item.sellingStyleNumber,
                                            item.selectedColor.colorNumber
                                              ? item.selectedColor.colorNumber
                                              : item.colors[0].colorNumber,
                                            item.roomsceneIds &&
                                              item.roomsceneIds[
                                                Math.floor(
                                                  Math.random() *
                                                    item.roomsceneIds.length
                                                )
                                              ],
                                            item.recommendedInstallationMethodsInfo &&
                                              item
                                                .recommendedInstallationMethodsInfo[0] &&
                                              item
                                                .recommendedInstallationMethodsInfo[0]
                                                .name
                                              ? item
                                                  .recommendedInstallationMethodsInfo[0]
                                                  .name
                                              : "1",
                                            500
                                          )
                                  },
                                  on: { error: _vm.handleImageError }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "img-close",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeCompareProduct(
                                          item.sellingStyleNumber
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("X")]
                                )
                              ])
                            ]
                          )
                        }
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn border border-dark justify-content-start mr-5 hide-mobile-tablet",
                          class: [
                            _vm.getCompareProducts.length <= _vm.sliceEnd
                              ? "disabled-prev-next-btn"
                              : ""
                          ],
                          on: { click: _vm.next }
                        },
                        [
                          _c("span", {
                            class: [
                              _vm.getCompareProducts.length <= _vm.sliceEnd
                                ? "png-icon png-icon-icons-glyph--g-chevron-right"
                                : "png-icon png-icon-icons-glyph--k-chevron-right"
                            ]
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary compare-button",
                          on: { click: _vm.openModal }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$resourceString[
                                  "product.Search.Label.Compare"
                                ]
                              ) +
                              "\n            "
                          ),
                          _c("span", {
                            staticClass:
                              "png-icon png-icon-icons-glyph--ko-arrow-next ml-3"
                          })
                        ]
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex hide-mobile-tablet" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-white border border-dark justify-content-start remove-all-button",
                        on: { click: _vm.removeAllCompareProduct }
                      },
                      [
                        _c("span", {
                          staticClass:
                            "png-icon png-icon-icons-glyph--k-close mr-3"
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$resourceString["common.removeAll"]) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }